import { Box, FormControl, Grid, MenuItem } from "@mui/material";
import "../../pages/Grafana/grafanaDiagram.scss";
import { StyledInputLabel, StyledSelect } from "../FormElements/CustomSelect";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Slider from "@mui/material/Slider";
import dayjs from "dayjs";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import ttData from "./ttPredictionData.json";
import rtmData from "./rtmPredictionData.json";

function PredictionForTTAndRTM({ organisation }) {
  const [url, setUrl] = useState(null);
  const [diagram, setDiagram] = useState(null);
  const [values, setValues] = useState({
    date: "",
    scale: 6,
    dateSelection: false,
  });
  const [sliderValues, setSliderValues] = useState({
    min: 0,
    max: 0,
  });
  const [time, setTime] = useState("");

  let datePickerStartDate = new Date("2017-01-01");
  let datePickerEndDate = new Date("2024-09-30");

  const timePeriods = [
    { name: "Daily short", id: "_daily_short" },
    { name: "Daily long", id: "_daily_long" },
    { name: "Monthly", id: "_monthly" },
  ];

  const description =
    organisation === "TT"
      ? "Choose the desired line from the options below to get the corresponding graph."
      : "Choose the desired station/line from the options below to get the corresponding graph.";

  const onPredictHandler = (e) => {
    e.preventDefault();
  };

  const dateSelectionhandler = () => {
    setValues((prevValues) => ({
      ...prevValues,
      dateSelection: !prevValues.dateSelection,
    }));
  };

  const onDateChange = (event) => {
    let a = event.$y + "/";
    let b = event.$M + 1;
    let c = "/" + event.$D;
    setValues((prevValues) => ({
      ...prevValues,
      date: a + b + c,
    }));
  };

  const onChangeScale = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      scale: event.target.value,
    }));
  };

  useEffect(() => {
    function calculateEndDate(dateToUpdate, startDate) {
      if (["_daily_short", "_daily_long"].includes(time)) {
        return dateToUpdate.setDate(startDate.getDate() + values.scale);
      } else if (time === "_monthly") {
        return dateToUpdate.setMonth(startDate.getMonth() + values.scale);
      }
    }

    if (values.dateSelection) {
      if (url === null) {
        setDiagram(null);
      } else {
        if (values.date !== "") {
          let startDate = new Date(values.date);
          let tempDate = new Date(startDate);
          let toDate = calculateEndDate(tempDate, startDate);
          let tempURL = new URL(url);
          tempURL.searchParams.set("from", startDate.getTime());
          tempURL.searchParams.set("to", new Date(toDate).getTime());
          setDiagram(tempURL.href);
        } else {
          setDiagram(url);
        }
      }
    } else {
      setDiagram(url);
    }
  }, [url, values, time]);

  useEffect(() => {
    let tempSlider = {};
    if (time === "_daily_short") {
      tempSlider = {
        min: 1,
        max: 7,
      };
    } else if (time === "_daily_long") {
      tempSlider = {
        min: 1,
        max: 14,
      };
    } else if (time === "_monthly") {
      tempSlider = {
        min: 1,
        max: 12,
      };
    } else {
      tempSlider = {
        min: 0,
        max: 0,
      };
    }
    setSliderValues(tempSlider);
  }, [time]);
  return (
    <div id="grafana-diagram-container">
      <div className="dashChart">
        <form onSubmit={onPredictHandler}>
          <div className="chartOptions chartBox grafana-inner flexColumn">
            <h2 className="grafanaTitle">Demand Prediction</h2>
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12} md={12}>
                  <p style={{ marginTop: "-24px" }}>
                    {description} You can optionally enable date selection to
                    pick a start date. The selectable range depends on your time
                    selection: 1–7 days for Daily Short, 1–14 days for Daily
                    Long, and 1–12 months for Monthly.
                  </p>

                  {organisation === "TT" && (
                    <OptionsForTT
                      timePeriods={timePeriods}
                      setUrl={setUrl}
                      time={time}
                      setTime={setTime}
                    />
                  )}
                  {organisation === "RTM" && (
                    <OptionsForRTM
                      timePeriods={timePeriods}
                      setUrl={setUrl}
                      time={time}
                      setTime={setTime}
                    />
                  )}
                </Grid>
              </Grid>
            </Box>

            <div className="dashChart">
              <FormControl size="small" fullWidth={true}>
                <div className="flexBox flexColumn">
                  <div className="grafanaType">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onClick={dateSelectionhandler}
                          style={{ color: "#35afaf" }}
                          checked={values.dateSelection}
                        />
                      }
                      label="Enable date selection"
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        format="DD/MM/YYYY"
                        onChange={onDateChange}
                        minDate={dayjs(datePickerStartDate)}
                        maxDate={dayjs(datePickerEndDate)}
                        slotProps={{
                          textField: { required: true },
                        }}
                        disabled={!values.dateSelection}
                      />
                    </LocalizationProvider>
                    <div
                      className="grafana-slider"
                      //   style={{
                      //     visibility: `${
                      //       dropdownValues.timePeriod === ""
                      //         ? "hidden"
                      //         : "visible"
                      //     }`,
                      //   }}
                    >
                      <span>{sliderValues.min}</span>
                      <Slider
                        size="medium"
                        defaultValue={values.scale}
                        aria-label="medium"
                        min={sliderValues.min}
                        max={sliderValues.max}
                        valueLabelDisplay="auto"
                        onChange={onChangeScale}
                        style={{
                          color: `${
                            !values.dateSelection ? "#4F4F4F" : "#35afaf"
                          }`,
                        }}
                        value={values.scale}
                        disabled={!values.dateSelection}
                      />
                      <span>{sliderValues.max}</span>
                    </div>
                    <FormControlLabel
                      control={<Checkbox style={{ color: "#35afaf" }} />}
                      style={{ visibility: "hidden" }}
                      label="COVID"
                    />
                  </div>
                </div>
              </FormControl>
            </div>
            <div className="dashChart">
              <FormControl size="small" fullWidth={true}>
                <div className="flexBox flexEnd">
                  {/* <Button
                    variant="contained"
                    size="medium"
                    type="submit"
                    // disabled={noDiagramAlert}
                  >
                    Predict
                  </Button> */}
                </div>
              </FormControl>
            </div>
          </div>
        </form>
        {diagram && (
          <Grid item xs={12} md={12}>
            <div className="chartBox">
              <div className="chartTitle">
                <div
                  style={{
                    padding: "10px",
                  }}
                >
                  <p>
                    ✨ Tip: You can zoom in on the graph by selecting an area
                    with your mouse. To zoom out, simply press{" "}
                    <strong>Ctrl + Z</strong>.
                  </p>
                </div>
              </div>
              <iframe
                src={diagram}
                width="100%"
                height="500"
                title={`prediction-chart`}
              ></iframe>
            </div>
          </Grid>
        )}
      </div>
    </div>
  );
}

export default PredictionForTTAndRTM;

function OptionsForTT({ timePeriods, setUrl, time, setTime }) {
  const [line, setLine] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "time") {
      setTime(value);
    } else {
      setLine(value);
    }
    setUrl(null);
  };

  useEffect(() => {
    if (line !== "" && time !== "") {
      let tempUrl = "";
      if (time === "_daily_short") {
        tempUrl = ttData.urlDailyShort;
      } else if (time === "_daily_long") {
        tempUrl = ttData.urlDailyLong;
      } else {
        tempUrl = ttData.urlMonthly;
      }
      setUrl(tempUrl + line + time);
    } else {
      setUrl(null);
    }
  }, [line, time, setUrl]);
  return (
    <div className="dashChart flexBox">
      <FormControl fullWidth={true}>
        <StyledInputLabel htmlFor={`line-data`}>Line</StyledInputLabel>
        <StyledSelect
          labelId={`line-data`}
          label={"Line"}
          onChange={handleChange}
          value={line}
          required
          name="line"
        >
          <MenuItem value=""></MenuItem>
          {ttData.lines.map((item) => (
            <MenuItem value={item.id} key={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
      <FormControl fullWidth={true}>
        <StyledInputLabel htmlFor={`time-period`}>Time period</StyledInputLabel>
        <StyledSelect
          labelId={`time-period`}
          label={"Time period"}
          onChange={handleChange}
          value={time}
          required
          name="time"
        >
          <MenuItem value=""></MenuItem>
          {timePeriods.map((item, index) => (
            <MenuItem value={item.id} key={index}>
              {item.name}
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </div>
  );
}

function OptionsForRTM({ timePeriods, setUrl, time, setTime }) {
  const [station, setStation] = useState("");
  const [type, setType] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "time") {
      setTime(value);
    } else if (name === "station") {
      setStation(value);
    } else {
      setType(value);
    }
    setUrl(null);
  };

  useEffect(() => {
    if (station !== "" && time !== "") {
      let tempUrl = "";
      if (time === "_daily_short") {
        tempUrl = rtmData.urlDailyShort;
      } else if (time === "_daily_long") {
        tempUrl = rtmData.urlDailyLong;
      } else {
        tempUrl = rtmData.urlMonthly;
      }
      setUrl(tempUrl + station + time);
    } else {
      setUrl(null);
    }
  }, [station, time, setUrl]);
  return (
    <div className="dashChart flexBox">
      <FormControl fullWidth={true}>
        <StyledInputLabel htmlFor={`type`}>Type</StyledInputLabel>
        <StyledSelect
          labelId={`type`}
          label={"Type"}
          onChange={handleChange}
          value={type}
          required
          name="type"
        >
          <MenuItem value=""></MenuItem>
          <MenuItem value="line">Line</MenuItem>
          <MenuItem value="station">Station</MenuItem>
        </StyledSelect>
      </FormControl>
      {type === "line" && (
        <FormControl fullWidth={true}>
          <StyledInputLabel htmlFor={`line-data`}>Line</StyledInputLabel>
          <StyledSelect
            labelId={`line-data`}
            label={"Line"}
            onChange={handleChange}
            value={station}
            required
            name="station"
          >
            <MenuItem value=""></MenuItem>
            {rtmData.stations
              .filter((element) => ["line", "global"].includes(element.type))
              .map((item) => (
                <MenuItem value={item.id} key={item.id}>
                  {item.name}
                </MenuItem>
              ))}
          </StyledSelect>
        </FormControl>
      )}
      {type === "station" && (
        <FormControl fullWidth={true}>
          <StyledInputLabel htmlFor={`station-data`}>Station</StyledInputLabel>
          <StyledSelect
            labelId={`station-data`}
            label={"Station"}
            onChange={handleChange}
            value={station}
            required
            name="station"
          >
            <MenuItem value=""></MenuItem>
            {rtmData.stations
              .filter((element) => !["line"].includes(element.type))
              .map((item) => (
                <MenuItem value={item.id} key={item.id}>
                  {item.station_name}
                </MenuItem>
              ))}
          </StyledSelect>
        </FormControl>
      )}

      <FormControl fullWidth={true}>
        <StyledInputLabel htmlFor={`time-period`}>Time period</StyledInputLabel>
        <StyledSelect
          labelId={`time-period`}
          label={"Time period"}
          onChange={handleChange}
          value={time}
          required
          name="time"
        >
          <MenuItem value=""></MenuItem>
          {timePeriods.map((item, index) => (
            <MenuItem value={item.id} key={index}>
              {item.name}
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </div>
  );
}
